// extracted by mini-css-extract-plugin
export var active = "staticpage-module--active--vh2AL";
export var closePopup = "staticpage-module--closePopup--TaoBX";
export var contactUs = "staticpage-module--contactUs--KcJ5f";
export var content = "staticpage-module--content--+a3aY";
export var country = "staticpage-module--country--ktgz2";
export var details = "staticpage-module--details--rNWQp";
export var dirTitle = "staticpage-module--dirTitle--6z5l7";
export var employeeContentWrap = "staticpage-module--employeeContentWrap--V-sMb";
export var employeeDiv = "staticpage-module--employeeDiv--5hKdy";
export var employeeDivWrapper = "staticpage-module--employeeDivWrapper--cv-kg";
export var employeeImg = "staticpage-module--employeeImg--X0QT+";
export var employeeName = "staticpage-module--employeeName--5v8oM";
export var faint = "staticpage-module--faint--1IU99";
export var fileUpload = "staticpage-module--fileUpload--NUkoE";
export var form = "staticpage-module--form--DZutm";
export var formDetails = "staticpage-module--formDetails--1lq-k";
export var heading = "staticpage-module--heading--VaG0B";
export var hideOnMobile = "staticpage-module--hideOnMobile--cioOI";
export var imgWrap = "staticpage-module--imgWrap--gNCD-";
export var loginForm = "staticpage-module--loginForm--qjOQh";
export var mediaLinks = "staticpage-module--mediaLinks--4dio1";
export var people = "staticpage-module--people--bC4Eu";
export var place = "staticpage-module--place--TC6kG";
export var popup = "staticpage-module--popup--HwhYn";
export var popupBottomSection = "staticpage-module--popupBottomSection--kJ2BL";
export var popupContent = "staticpage-module--popupContent--7whKn";
export var popupTopSection = "staticpage-module--popupTopSection--faerK";
export var rainbowTextSimpleAnimation = "staticpage-module--rainbow-text-simple-animation--UpPx5";
export var rainbowTextSimpleAnimationRev = "staticpage-module--rainbow-text-simple-animation-rev--t0XZP";
export var shawBtn = "staticpage-module--shawBtn--x+si-";
export var show = "staticpage-module--show--YVmPn";
export var showOnMobile = "staticpage-module--showOnMobile--9SScM";
export var socialIcons = "staticpage-module--socialIcons--hyMv5";
export var specific = "staticpage-module--specific--lm4FR";
export var staticPage = "staticpage-module--staticPage--w1-RO";
export var subHeading = "staticpage-module--subHeading--MHcK+";
export var tabHeader = "staticpage-module--tabHeader--1UmYX";
export var teamDescription = "staticpage-module--teamDescription--3CsHf";
export var teamHeader = "staticpage-module--teamHeader--WHm1I";
export var uploadCta = "staticpage-module--uploadCta--GUqm0";
export var userDetails = "staticpage-module--userDetails--WUfII";